"use client";

/**
 * CallButton component
 * Renders a phone call button for hotel or global phone numbers in the header.
 */

import { Icon } from "@/components/atoms/icon";
import { Link } from "@/components/atoms/link";

interface CallButtonProps {
  globalPhone?: string;
  hotelPhone?: string;
}

export default function CallButton({
  globalPhone,
  hotelPhone,
}: Readonly<CallButtonProps>) {
  // Render call button with appropriate phone number
  return (
    <div className="flex h-8 w-8 items-center justify-center rounded-2xl bg-[var(--fill-base-main)] text-center lg:hidden">
      <Link 
        href={`tel: ${hotelPhone || globalPhone}`}
        aria-label="電話でお問い合わせ"
      >
        <Icon icon={"header-phone"} aria-hidden="true"></Icon>
      </Link>
    </div>
  );
}
